import { ChannelIconOverrides } from './types';

export const DEFAULTS: ChannelIconOverrides = {
  Emoji: {
    size: 20,
  },
  Icon: {
    fillColorToken: 'icon-placeholder',
    className: 'w-20 h-20 flex-none',
  },
};
